import { render, staticRenderFns } from "./EndpointStatsPage.vue?vue&type=template&id=3abd269c&scoped=true&"
import script from "./EndpointStatsPage.vue?vue&type=script&lang=js&"
export * from "./EndpointStatsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abd269c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abd269c')) {
      api.createRecord('3abd269c', component.options)
    } else {
      api.reload('3abd269c', component.options)
    }
    module.hot.accept("./EndpointStatsPage.vue?vue&type=template&id=3abd269c&scoped=true&", function () {
      api.rerender('3abd269c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/EndpointStatsPage.vue"
export default component.exports